import { Box, Grid } from "@material-ui/core";
import { Typeahead } from "react-bootstrap-typeahead";
import "react-bootstrap-typeahead/css/Typeahead.css";
import styles from "../communication-chat.module.css";
import { Search } from "react-feather";
import { FormControl, MenuItem, Select } from "@mui/material";
import { useState } from "react";

const ALL_FILTER_OPTIONS = [
  { value: "tenant", label: "Tenant", placeholder: "Search by tenants" },
  { value: "prospect", label: "Prospect", placeholder: "Search by prospects" },
  { value: "employee", label: "Employee", placeholder: "Search by employees" },
];

const ProspectTenantSearch = (props) => {
  // Only the options this user has access to (same rule as the management
  // app): Employee needs smschat-team:read, Tenant/Prospect need
  // smschat-tenant:read. Order is unchanged, so Tenant is the default when
  // available, falling back to Employee.
  const FILTER_OPTIONS = ALL_FILTER_OPTIONS.filter((opt) => {
    if (opt.value === "employee") return !!props.hasTeamRead;
    return !!props.hasTenantRead;
  });

  const [filterType, setFilterType] = useState(FILTER_OPTIONS[0]?.value || "");

  const currentFilter = FILTER_OPTIONS.find((o) => o.value === filterType);

  const filterByCallback = (option, props) => {
    const searchText = props.text.toLowerCase().trim();

    if (option.type?.toLowerCase() !== filterType) return false;

    const fullName = `${option.first_name || ""} ${option.last_name || ""}`
      .toLowerCase()
      .trim();

    return (
      fullName.includes(searchText) ||
      option.first_name?.toLowerCase().includes(searchText) ||
      option.last_name?.toLowerCase().includes(searchText) ||
      option.phone?.includes(searchText) ||
      option.property_name?.toLowerCase().includes(searchText) ||
      option.apt_no?.toLowerCase().includes(searchText) ||
      option.role?.toLowerCase().includes(searchText)
    );
  };

  const filterEmployeeByCallback = (option, props) => {
    const searchText = props.text.toLowerCase().trim();
    return (
      option.name?.toLowerCase().includes(searchText) ||
      option.role?.toLowerCase().includes(searchText) ||
      option.property?.toLowerCase().includes(searchText)
    );
  };

  return (
    <div className={`${styles.SearchSecMain} ${props.showSearch ? styles.Active : ""}`}>
      <div className={`${styles.SelectTypeSearch} FormGroup`}>
        <FormControl fullWidth size="small">
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={filterType}
            onChange={(e) => setFilterType(e.target.value)}
            size="small"
            MenuProps={{
              PaperProps: {
                sx: {
                  "& .MuiMenuItem-root": {
                    fontSize: "12px",
                    minHeight: "30px",
                    padding: "4px 10px",
                  },
                },
              },
            }}
          >
            {FILTER_OPTIONS.map((opt) => (
              <MenuItem key={opt.value} value={opt.value}>
                {opt.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>

      {filterType === "employee" ? (
        <div className={`${styles.SearchSecUnder} SearchSecUnder`}>
          <Search />
          <Typeahead
            id="search-employees"
            key="employee"
            labelKey={(option) => option.name || ""}
            filterBy={filterEmployeeByCallback}
            options={props.employeeDirectory || []}
            placeholder={currentFilter?.placeholder}
            clearButton={true}
            flip={true}
            onChange={(selected) => {
              const emp = selected[0];
              if (emp) props.onSelectEmployeeTypeahead(emp);
            }}
            emptyLabel="No results found"
            renderMenuItemChildren={(option) => (
              <div className={`${styles.Width100}`}>
                <div className={`${styles.SearchTPDeRow}`}>
                  <span className={`${styles.SearchTPDeName}`}>
                    {option.name}
                  </span>
                  <span className={`${styles.SearchTPDeDe}`}>
                    <span>{option.property}</span>
                    <span>{option.role}</span>
                  </span>
                </div>
              </div>
            )}
          />
        </div>
      ) : (
        <div className={`${styles.SearchSecUnder} SearchSecUnder`}>
          <Search />
          <Typeahead
            id="search-tenants"
            key={filterType}
            labelKey={(option) => {
              if (option && option.first_name && option.last_name) {
                return option.first_name + " " + option.last_name;
              } else {
                return option.phone;
              }
            }}
            filterBy={(option, props) => filterByCallback(option, props)}
            options={props.typeaheadProspectTenantList}
            placeholder={currentFilter?.placeholder}
            clearButton={true}
            flip={true}
            onChange={props.onSelectTypeahead}
            emptyLabel="No results found"
            renderMenuItemChildren={(option) => (
              <div className={`${styles.Width100}`}>
                {option && (option?.first_name || option?.last_name) ? (
                  <div className={`${styles.SearchTPDeRow}`}>
                    <span className={`${styles.SearchTPDeName}`}>
                      {option?.first_name} {option?.last_name}
                    </span>
                    <span className={`${styles.SearchTPDeDe}`}>
                      <span>{option?.property_name}</span>
                      {option?.type !== "Employee" && (
                        <span>{option?.apt_no}</span>
                      )}
                    </span>
                  </div>
                ) : (
                  <div>{option?.phone}</div>
                )}
              </div>
            )}
          />
        </div>
      )}
    </div>
  );
};

export default ProspectTenantSearch;
